import React, { memo, useState, useEffect } from 'react';
import CommonFirstStepCard from '../CommonFirstStepCard';
import styles from '../UserKycStepOne.module.css';
import pancard_icon from '../../../../images/icons/UserKycIcons/pancard_icon.svg';
import selfie_icons from '../../../../images/icons/UserKycIcons/selfie_icons.svg';
import aadharCard_icon from '../../../../images/icons/UserKycIcons/aadharCard_icon.svg';
import addressproof_icon from '../../../../images/icons/UserKycIcons/addressproof_icon.svg';
import verified_icon from '../../../../images/icons/UserKycIcons/verified_icon.svg';
import tealArrow from '../../../../images/icons/UserKycIcons/tealArrow.svg';
import orangeArrow from '../../../../images/icons/UserKycIcons/orangeArrow.svg';
import purpleArrow from '../../../../images/icons/UserKycIcons/purpleArrow.svg';
import blueArrow from '../../../../images/icons/UserKycIcons/blueArrow.svg';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
const validationSchema = Yup.object().shape({
  document: Yup.string().required('Required')
});
const AddressProofContainer = props => {
  return (
    <Formik
      initialValues={{
        document: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        console.log('submitsubmit', data);
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting
      }) => {
        let documentList = [
          {
            label: 'Voter ID',
            value: 'Voter ID'
          },
          {
            label: 'Passport',
            value: 'Passport'
          },
          {
            label: 'Driving License',
            value: 'Driving License'
          },
          {
            label: 'Bank Statement',
            value: 'Bank Statement'
          },
          {
            label: 'Bank Passbook',
            value: 'Bank Passbook'
          },
          {
            label: 'Utility Bill',
            value: 'Utility Bill'
          },{
            label: 'HR Letter',
            value: 'HR Letter'
          }




        ];
        // const { box } = styles;
        const [document, setDocument] = useState('');
        const initialDesign = [
          {
            img: addressproof_icon,
            textColor: 'text-blue-900',
            bgColor: 'bg-blue-100',
            ColoredArrow: blueArrow,
            step: 4,
            discription: 'Now Please Upload Current Address Proof'
          }
        ];
        handleChange = val => {
          console.log(val);
        };
        return (
          <Form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="pt-2 mx-5"
          >
            {/* <div className={`${box}`}> */}
            <div className=''>
              {props.cardShow
                ? initialDesign.map((each, i) => {
                    return <CommonFirstStepCard key={i} sendeach={each} />;
                  })
                : null}
              <div className="w-full  mr-auto py-3 md:py-3 max-w-xs">
                <div className="text-black-600 font-roboto font-normal text-md font-bold pb-2">
                  Select any 1 address Proof
                </div>
                <CommonSelect sort={true}
                  name="document"
                  value={values.document}
                  onChange={e => {
                    setFieldValue('document', {
                      value: e.value,
                      label: e.value
                    }),
                      handleChange(e.value);
                      props.setSelected( e.value)
                  }}
                  options={[...documentList]}
                  isHoverEffect
                  stylesContainer={{
                    height: '52px',
                    marginBottom: '0px',
                    fontSize: '40px'
                  }}
                  dropdownStyle={{
                    top: '52px',
                    color: 'rgba(0,0,0,0.87)',
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    alignItems: 'center',
                    fontFamily: 'Roboto',
                    fontWeight: 400
                  }}
                  styleText={{
                    fontSize: '14px',
                    padding: '0 25px'
                  }}
                  error={
                    touched.document && get(errors, 'document.value', false)
                  }
                  touched={touched.document}
                  onBlur={e => {
                    () => {};
                  }}
                />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default AddressProofContainer;
